import { action } from 'typesafe-actions';
import { EmployeeStatus, EmployeeType, ICard, ICreateEmployee, ICreateEmployeeSite, IEmployee, IUpdateEmployee, IUpdateEmployeeSite } from 'types';
import { Employee } from './types';

export interface IEmployeeMeta {
  successMessage?: string;
  onSuccess?: (employee?: IEmployee) => void;
  onDuplicate?: (dupEmployee?: IEmployee) => void;
  failToast?: Record<'message', string> | boolean;
  isReviewingEmployee?: boolean;
  preventToast?: boolean;
}

export const getEmployeeRequest = (employeeId: string) => action(Employee.GET_EMPLOYEE_REQUEST, { employeeId });
export const getEmployeeSuccess = (response: IEmployee) => action(Employee.GET_EMPLOYEE_SUCCESS, response);
export const getEmployeeError = (error: any) => action(Employee.GET_EMPLOYEE_FAIL, error, { failToast: true });

export const addEmployeeRequest = (body: ICreateEmployee, meta?: IEmployeeMeta) => action(Employee.ADD_EMPLOYEE_REQUEST, { body }, meta);
export const addEmployeeSuccess = (response: IEmployee, meta?: IEmployeeMeta) => action(Employee.ADD_EMPLOYEE_SUCCESS, response, meta);
export const addEmployeeError = (error: any, meta?: IEmployeeMeta) => action(Employee.ADD_EMPLOYEE_FAIL, error, meta);

export const updateEmployeeRequest = (employeeId: string, body: IUpdateEmployee, meta?: IEmployeeMeta) => action(Employee.UPDATE_EMPLOYEE_REQUEST, { employeeId, body }, meta);
export const updateEmployeeSuccess = (response: IEmployee, meta?: IEmployeeMeta) => action(Employee.UPDATE_EMPLOYEE_SUCCESS, response, meta);
export const updateEmployeeError = (error: any, meta?: IEmployeeMeta) => action(Employee.UPDATE_EMPLOYEE_FAIL, error, meta);

export const resendInvitationRequest = (employeeId: string, inviteRecipient: string, meta?: IEmployeeMeta) =>
  action(
    Employee.UPDATE_EMPLOYEE_REQUEST,
    {
      employeeId,
      body: { inviteRecipient },
    },
    {
      successMessage: 'Invitation sent successfully.',
      failToast: {
        message: `There was an error sending invite to ${inviteRecipient}`,
      },
      isReviewingEmployee: true,
      ...meta,
    }
  );

export const approveEmployeeRequest = (employeeId: string, onSuccess?: () => void) =>
  action(Employee.UPDATE_EMPLOYEE_REQUEST, { employeeId, body: { status: EmployeeStatus.APPROVED } }, { successMessage: 'Successfully approved employee', onSuccess, isReviewingEmployee: true });

export const updateOrgEmployeeTypeRequest = (employeeId: string, onSuccess?: (employee: IEmployee) => void) =>
  action(Employee.UPDATE_EMPLOYEE_REQUEST, { employeeId, body: { type: EmployeeType.ADMIN } }, { successMessage: 'Employee successfully updated to Org Admin', onSuccess });

export const addEmployeeToSiteRequest = (employeeId: string, body: ICreateEmployeeSite, meta?: IEmployeeMeta) =>
  action(Employee.ADD_EMPLOYEE_TO_SITE_REQUEST, { employeeId, body }, { ...meta, successMessage: meta?.successMessage || 'Employee added to site successfully' });
export const addEmployeeToSiteSuccess = (response: IEmployee) => action(Employee.ADD_EMPLOYEE_TO_SITE_SUCCESS, response);
export const addEmployeeToSiteError = (error: any) => action(Employee.ADD_EMPLOYEE_TO_SITE_FAIL, error);

export const removeEmployeeFromSiteRequest = (employeeId: string, siteId: string, meta?: { successMessage?: string }) => action(Employee.REMOVE_EMPLOYEE_FROM_SITE_REQUEST, { employeeId, siteId }, meta);
export const removeEmployeeFromSiteSuccess = (response: IEmployee) => action(Employee.REMOVE_EMPLOYEE_FROM_SITE_SUCCESS, response);
export const removeEmployeeFromSiteError = (error: any) => action(Employee.REMOVE_EMPLOYEE_FROM_SITE_FAIL, error);

export const updateEmployeeSiteRoleRequest = (employeeId: string, siteId: string, body: IUpdateEmployeeSite, meta?: IEmployeeMeta) => action(Employee.UPDATE_EMPLOYEE_SITE_ROLE_REQUEST, { employeeId, siteId, body }, meta);
export const updateEmployeeSiteRoleSuccess = (response: IEmployee) => action(Employee.UPDATE_EMPLOYEE_SITE_ROLE_SUCCESS, response);
export const updateEmployeeSiteRoleError = (error: any) => action(Employee.UPDATE_EMPLOYEE_SITE_ROLE_FAIL, error);

export const getEmployeeCardRequest = (employeeId: string, cardId: string) => action(Employee.GET_EMPLOYEE_CARD_REQUEST, { employeeId, cardId });
export const getEmployeeCardSuccess = (response: ICard) => action(Employee.GET_EMPLOYEE_CARD_SUCCESS, response);
export const getEmployeeCardError = (error: any) => action(Employee.GET_EMPLOYEE_CARD_FAIL, error);

export const deleteEmployeeRequest = (employeeId: string, onSuccess: () => void) => action(Employee.DELETE_EMPLOYEE_REQUEST, { employeeId }, { onSuccess });
export const deleteEmployeeSuccess = (response: IEmployee) => action(Employee.DELETE_EMPLOYEE_SUCCESS, response);
export const deleteEmployeeError = (error: any) => action(Employee.DELETE_EMPLOYEE_FAIL, error, { failToast: true });
